module.exports = __webpack_public_path__ + "img/oskar-plain.d154d997.svg";